import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

export type DrawerIconType =
  | 'pencil'
  | 'tinyEraser'
  | 'smallEraser'
  | 'mediumEraser'
  | 'bigEraser'
  | 'figures'
  | 'text'
  | 'eye'
  | 'bg'
  | 'bgWhite'
  | 'bgElementarySchoolLines'
  | 'bgLines'
  | 'bgGrid'
  | 'bgAxis'
  | 'rectangle'
  | 'circle'
  | 'line'
  | 'leftArrow'
  | 'rightArrow'
  | 'minimizeArrow'
  | 'backArrow'
  | 'bgGray'
  | 'trashbin'
  | 'fontBigger'
  | 'fontSmaller'
  | 'colorPicker'
  | 'cog'
  | 'save'
  | 'polygon1'
  | 'polygon2'
  | 'transparent'
  | 'semiTransparent'
  | 'opaque'
  | 'thinLine'
  | 'normalLine'
  | 'thickLine'
  | 'videoPlayer'
  | 'audioPlayer'
  | 'clearAll'
  | 'showOnlyOneExample'
  | 'showAllExample'
  | 'showTip'
  | 'showAnswer'
  | 'eyeDisabled'
  | 'penSettings';

@Component({
  selector: 'txtb-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IconsComponent {
  @Input() type: DrawerIconType = 'pencil';
  @Input() fill?: string | null;
  @Input() stroke?: string | null;
}
